import toggleClass from 'utils/DOM/toggleClass'
import getById from 'utils/DOM/getById'

let timeoutID
const wrap = getById('toast-wrap')
const nodeId = getById('toast-message')

function removeToast() {
  window.clearTimeout(timeoutID)
  toggleClass(wrap, 'show', false)
}

function toastNotification(message, end = 2500) {
  if (timeoutID) {
    removeToast()
  }

  nodeId.textContent = message
  toggleClass(wrap, 'show', true)
  timeoutID = window.setTimeout(removeToast, end)
}

export default toastNotification
